"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ArrowLeftSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7.85710678,6.14212718 C8.05049539,6.33551579 8.05074179,6.64898459 7.85765744,6.84267698 L5.70710678,9 L14,9 L14,10 L5.70710678,10 L7.85728896,12.1524212 C8.05051745,12.3458509 8.0504359,12.6592741 7.85710678,12.8526033 C7.66371856,13.0459915 7.35025004,13.0462368 7.15655932,12.8531516 L3.79289322,9.5 L7.1568079,6.14182805 C7.35032102,5.94864528 7.66375877,5.94877917 7.85710678,6.14212718 Z" })));
};
ArrowLeftSmall.displayName = 'ArrowLeftSmall';
exports.default = ArrowLeftSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowLeftSmall.js.map